import { type ReactNode } from 'react';
import { Badge } from './ui.js';

interface PageHeaderProps {
  title: string;
  subtitle?: ReactNode;
  badge?: ReactNode;
  actions?: ReactNode;
}

/** Presentational page header: title row with optional badge, optional subtitle, optional actions. */
export function PageHeader({ title, subtitle, badge, actions }: PageHeaderProps) {
  return (
    <header className="page-head">
      <div>
        <div className="page-title-row">
          <h1>{title}</h1>
          {badge ?? null}
        </div>
        {subtitle ? <p className="page-subtitle muted small">{subtitle}</p> : null}
      </div>
      {actions ? <div className="page-actions">{actions}</div> : null}
    </header>
  );
}
